import React from 'react';
import { useTranslation } from 'react-i18next';
import AdminHeader from '../../components/admin/AdminHeader';

const NotImplementedPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-gray-100">
      <AdminHeader subtitleKey="admin.menu.dashboard" />
      <main className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <div className="px-4 py-6 sm:px-0">
          <div className="border-4 border-dashed border-gray-200 rounded-lg p-6">
            <h2 className="text-xl font-semibold mb-2">{t('admin.menu.dashboard')}</h2>
            <p className="text-sm text-gray-600">{t('admin.dashboard.pageNotImplemented')}</p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default NotImplementedPage;